import { useState, useEffect, useMemo } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";
import themeDark from "assets/theme-dark";
import themeDarkRTL from "assets/theme-dark/theme-rtl";
import { CacheProvider } from "@emotion/react";
import routes from "routes";
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "context";
import brandWhite from "assets/images/logo-ct.png";
import brandDark from "assets/images/logo-ct-dark.png";
import ProductDetails from "layouts/products/ProductDetails";
import AddProduct from "layouts/products/AddProduct";
import Profile from "layouts/profile";
import EditProduct from "layouts/products/EditProduct";
import AddProductImage from "layouts/products/AddProductImage";
import Cookies from "js-cookie";
import SignIn from "layouts/authentication/sign-in";
import CloneProduct from "layouts/products/CloneProduct";
import SubCategory from "layouts/subCategory";
import SubCategoryProducts from "layouts/subCategoryProducts";

export default function App () {
  const navigate = useNavigate();

  useEffect(() => {
    const token = Cookies.get("adminToken");
    if (!token) {
      navigate("/sign-in");
      return;
    }

    try {
      if (!token) {
        console.log("Token expired.");
        localStorage.removeItem("adminToken");
        navigate("/sign-in");
      } else {
        console.log("Valid token");
      }
    } catch (error) {
      console.error("Invalid token:", error);
      localStorage.removeItem("adminToken");
      navigate("/sign-in");
    }
  }, [navigate]);

  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = allRoutes =>
    allRoutes.map(route => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return direction === "rtl" ? (
    <CacheProvider value={rtlCache}>
      <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
        <CssBaseline />
        {layout === "dashboard" && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
              brandName='Gym Bazaar'
              routes={routes}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
            <Configurator />
            {/* {configsButton} */}
          </>
        )}
        {layout === "vr" && <Configurator />}
        <Routes>
          {getRoutes(routes)}
          <Route path='*' element={<Navigate to='/dashboard' />} />
          <Route path='/profile' element={<Profile />} />
          <Route path='/sign-in' element={<SignIn />} />
          <Route path='/add-product' element={<AddProduct />} />
          <Route path='/clone-product' element={<CloneProduct />} />
          <Route path='/edit-product' element={<EditProduct />} />
          <Route path='/product-details' element={<ProductDetails />} />
          <Route path='/add-product-image' element={<AddProductImage />} />
          <Route path='/sub-category' element={<SubCategory />} />
          <Route path='/sub-category-products' element={<SubCategoryProducts />} />
        </Routes>
      </ThemeProvider>
    </CacheProvider>
  ) : (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {layout === "dashboard" && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
            brandName='Gym Bazaar'
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
          <Configurator />
          {/* {configsButton} */}
        </>
      )}
      {layout === "vr" && <Configurator />}
      <Routes>
        {getRoutes(routes)}
        <Route path='/profile' element={<Profile />} />
        <Route path='/sign-in' element={<SignIn />} />
        <Route path='*' element={<Navigate to='/dashboard' />} />
        <Route path='/add-product' element={<AddProduct />} />
        <Route path='/clone-product' element={<CloneProduct />} />
        <Route path='/edit-product' element={<EditProduct />} />
        <Route path='/product-details' element={<ProductDetails />} />
        <Route path='/add-product-image' element={<AddProductImage />} />
        <Route path='/sub-category' element={<SubCategory />} />
        <Route path='/sub-category-products' element={<SubCategoryProducts />} />
      </Routes>
    </ThemeProvider>
  );
}
